import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterialV5 from "./DeleteMaterialV5";
import CatalogProductDetailModalV5 from "../Common/CatalogModal/CatalogProductDetailModalV5";

import MaterialBarCodeModal from "./MaterialBarCodeModal";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import ShowUploadImageV5 from "./ShowUploadImageV5";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  addMaterial,
  //   getMaterialList,
  materialBarcodeList,
} from "../../../../redux/feature/customer_app/customerSlice";
// import MaterialHBModalV5 from "./MaterialHBModalV5";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate } from "../../../../common/Validations";
import MaterialListQualityCheckModal from "./MaterialListQualityCheckModal";
import MaterialBarcodeDetails from "./MaterialBarcodeDetails";
import MaterialHBModalV5Barcode from "./MaterialHBModalV5Barcode";
import BarcodeBulkUploadModal from "./BulkUpload/BarcodeBulkUpload";
import DownloadBarcodeTemplateMR from "./BulkUpload/DownloadBarcodeTemplateMR";

const MaterialBarcodeList = () => {
  localStorage.setItem("menu", "Barcode");
  localStorage.setItem("submenu", "Product Barcode");

  const dispatch = useDispatch();

  let materialData = useSelector(
    (state) => state?.customer?.materialBarcode?.data,
  ); // User Details from Store
  let materialTable = useSelector(
    (state) => state?.customer?.materialBarcode?.pagination,
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  // console.log(">>getCommonSearchTxt", getCommonSearchTxt);
  const [getNewPerPage, setNewPerPage] = useState(100);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowAddProductMaterial, setModalShowAddProductMaterial] =
    useState();
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);

  const [showBulkUpload, setShowBulkUpload] = useState(false);

  const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");
  const isSalesAdmin =
    storedUserData?.data?.roles?.some(
      (role) => role.roleId === "SALES-ADMIN",
    ) || false;

  const target = useRef(null);

  //   const getRoiExpiryDate = (createdOn) => {
  //   if (!createdOn) return "--";

  //   const date = new Date(createdOn);
  //   date.setMonth(date.getMonth() + 36);

  //   return date.toISOString().split("T")[0]; // YYYY-MM-DD
  // };

  const getRoiExpiryDate = (createdOn) => {
    if (!createdOn) return null;

    const date = new Date(createdOn);
    date.setMonth(date.getMonth() + 36);

    return date; // return Date object
  };

  const getRoiAgeMonthsDays = (createdOn) => {
    if (!createdOn) return "--";

    const start = new Date(createdOn);
    const today = new Date();

    if (today < start) return "0 Days";

    let years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();
    let days = today.getDate() - start.getDate();

    if (days < 0) {
      // previous month days
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months -= 1;
    }

    if (months < 0) {
      months += 12;
      years -= 1;
    }

    const totalMonths = years * 12 + months;

    let result = "";
    if (totalMonths > 0)
      result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
    result += `${days} Day${days !== 1 ? "s" : ""}`;

    return result.trim();
  };

  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showQCModal, setShowQCModal] = useState(false);
  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  useEffect(() => {
    if (!materialData || materialData.length === 0) return;

    const qcItems = [];

    materialData.forEach((row) => {
      // API lo already QC details unte
      if (row.qualityCheckDetails?.length) {
        row.qualityCheckDetails.forEach((qc) => {
          qcItems.push({
            ...row,
            ...qc, // modelMatch, brandMatch etc
            grnItemNr: qc.grnItemNr,
            qcType: qc.qcType,

            hasPhysicalQC: qc.qcType === "PHYSICAL",
            hasSpecificationQC: qc.qcType === "SPECIFICATION",
          });
        });
      }
    });

    setQualityCheckItems(qcItems);
  }, [materialData]);

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}),
    });
    setShowQCModal(true);
  };
  // eslint-disable-next-line
  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };
  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}),
    });
    setShowQCModal(true);
  };

  // new
  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.grnItemNr === qcPayload.grnItemNr &&
          item.qcType === qcPayload.qcType,
      );

      // UPDATE EXISTING
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        };
        return updated;
      }

      // ADD NEW
      return [
        ...prev,
        {
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        },
      ];
    });
  };

  // end
  // const handleSaveQualityCheck = (qcPayload) => {
  //   // console.log("Saving QC Payload:", qcPayload);

  //   setQualityCheckItems((prev) =>
  //     prev.map((item) => {
  //       if (item.grnItemNr !== qcPayload.grnItemNr) {
  //         return item;
  //       }

  //       return {
  //         ...item,

  //         //  merge QC form values
  //         ...qcPayload,

  //         //  update flags correctly
  //         hasPhysicalQC:
  //           qcPayload.qcType === "PHYSICAL" ? true : item.hasPhysicalQC,

  //         hasSpecificationQC:
  //           qcPayload.qcType === "SPECIFICATION"
  //             ? true
  //             : item.hasSpecificationQC,
  //       };
  //     })
  //   );
  // };

  // const getRoiExpiryFromCreatedAt = (createdAt) => {
  //   if (!createdAt) return "--";

  //   const date = new Date(createdAt);
  //   date.setMonth(date.getMonth() + 36);

  //   return date.toLocaleString("en-GB", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //   });
  // };

  // const getRoiAgeFromCreatedAt = (createdAt) => {
  //   if (!createdAt) return "--";

  //   const start = new Date(createdAt);
  //   const now = new Date();

  //   if (now < start) return "0 Days";

  //   let years = now.getFullYear() - start.getFullYear();
  //   let months = now.getMonth() - start.getMonth();
  //   let days = now.getDate() - start.getDate();

  //   if (days < 0) {
  //     const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  //     days += prevMonth.getDate();
  //     months -= 1;
  //   }

  //   if (months < 0) {
  //     months += 12;
  //     years -= 1;
  //   }

  //   const totalMonths = years * 12 + months;

  //   // Time difference
  //   let hours = now.getHours() - start.getHours();
  //   let minutes = now.getMinutes() - start.getMinutes();

  //   if (minutes < 0) {
  //     minutes += 60;
  //     hours -= 1;
  //   }

  //   if (hours < 0) {
  //     hours += 24;
  //   }

  //   let result = "";
  //   if (totalMonths > 0) result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
  //   result += `${days} Day${days !== 1 ? "s" : ""} `;
  //   result += `${hours}h ${minutes}m`;

  //   return result.trim();
  // };

  const isRentGodown = materialData?.some((row) => row.godown === "Rent");

  const rentOnlyColumns = [
    {
      name: "Created On",
      selector: (row) => row.createdOn || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-success">
          {formatDate(row.createdOn)}
        </p>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "ROI (Months)",
      selector: (row) => row.roiCodeMonths || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.roiCodeMonths}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "ROI Expiry Date",
      selector: (row) =>
        getRoiExpiryDate(row.createdOn)
          ? formatDate(getRoiExpiryDate(row.createdOn))
          : "--",
      cell: (row) => {
        const expiryDate = getRoiExpiryDate(row.createdOn);
        return (
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {expiryDate ? formatDate(expiryDate) : "--"}
          </p>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "ROI Age",
      selector: (row) => getRoiAgeMonthsDays(row.createdOn || row.createdDate),
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {getRoiAgeMonthsDays(row.createdOn || row.createdDate)}
        </p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "AC Asset Type",
      selector: (row) => row.acAssetType || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.acAssetType}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Asset Status",
      cell: (row) => (
        <TableStatusField
          status={row.assetActiveInactive ? "Active" : "Inactive"}
        />
      ),
      width: "130px",
    },
  ];

  const columns = [
    {
      name: "Edit Barcode",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title=""
            className="btn d-flex align-items-center w-100 text-success"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct12("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "View",
      id: "materialImage",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <button
          className="btn btn-table d-flex"
          onClick={() => showAddProduct12("DETAILS", row.documentNumber, row)}
        >
          <i class="bi bi-eye mx-2"></i>
          View
        </button>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Edit ROI",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Barcode Code",
      id: "barcode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.barcode || "--",
      cell: (row) => (
        <div className="ms-2">
          <p className="m-0 p-0 pt-1 fw-medium">{row?.barcode} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Active/InActive",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },

    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">1</p>
        </div>
      ),
      width: "80px",
    },

    {
      name: "Rate",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.orderPriceUnit ?? row.unitPrice}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "M R P",
      selector: (row) => row.mrPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.mrPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Quality Check",
    //   width: "240px",
    //   cell: (row) => (
    //     <div className="d-flex gap-3 ms-1">
    //       {/* PHYSICAL */}
    //       <div>
    //         {/* <input
    //       type="checkbox"
    //       checked={row.hasPhysicalQC || false}
    //       readOnly
    //       onClick={(e) => handleCheckboxClick("PHYSICAL", row, e)}
    //     /> */}
    //         <label
    //           className="ms-1 fw-bold cursor-pointer"
    //           onClick={() => {
    //             if (row.hasPhysicalQC) {
    //               handleViewQC("PHYSICAL", row);
    //             } else {
    //               handleQCCheck("PHYSICAL", row);
    //             }
    //           }}
    //         >
    //           Physical
    //         </label>
    //       </div>

    //       {/* SPECIFICATION */}
    //       <div>
    //         {/* <input
    //       type="checkbox"
    //       checked={row.hasSpecificationQC || false}
    //       readOnly
    //       onClick={(e) => handleCheckboxClick("SPECIFICATION", row, e)}
    //     /> */}
    //         <label
    //           className="ms-1 fw-bold cursor-pointer"
    //           onClick={() => {
    //             if (row.hasSpecificationQC) {
    //               handleViewQC("SPECIFICATION", row);
    //             } else {
    //               handleQCCheck("SPECIFICATION", row);
    //             }
    //           }}
    //         >
    //           Specification
    //         </label>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      name: "Quality Check",
      width: "260px",
      cell: (row) => (
        <div className="d-flex gap-4 ms-1 align-items-center">
          {/* 🔹 PHYSICAL QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasPhysicalQC) {
                handleViewQC("PHYSICAL", row);
              } else {
                handleQCCheck("PHYSICAL", row);
              }
            }}
            title={row.hasPhysicalQC ? "View Physical QC" : "Add Physical QC"}
          >
            <i
              className={`bi ${
                row.hasPhysicalQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Physical</span>
          </div>

          {/* 🔹 SPECIFICATION QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasSpecificationQC) {
                handleViewQC("SPECIFICATION", row);
              } else {
                handleQCCheck("SPECIFICATION", row);
              }
            }}
            title={
              row.hasSpecificationQC
                ? "View Specification QC"
                : "Add Specification QC"
            }
          >
            <i
              className={`bi ${
                row.hasSpecificationQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Specification</span>
          </div>
        </div>
      ),
    },

    ...(isRentGodown ? rentOnlyColumns : []),

    //      {
    //       name: "Created On",
    //       selector: (row) => row.createdOn || "--",
    //       cell: (row) => (
    //         <div>
    //           <p className="m-0 p-0 pt-1 fw-bold text-success">{formatDate(row.createdOn)} </p>
    //         </div>
    //       ),
    //       sortable: true,
    //       width: "120px",
    //     },

    //     {
    //       name: "ROI (Months)",
    //       selector: (row) => row.roiCodeMonths || "--",
    //       cell: (row) => (
    //         <div>
    //           <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.roiCodeMonths} </p>
    //         </div>
    //       ),
    //       sortable: true,
    //       width: "140px",
    //     },
    //     {
    //   name: "ROI Expiry Date",
    //   selector: (row) =>
    //     getRoiExpiryDate(row.createdOn)
    //       ? formatDate(getRoiExpiryDate(row.createdOn))
    //       : "--",

    //   cell: (row) => {
    //     const expiryDate = getRoiExpiryDate(row.createdOn);

    //     return (
    //       <div>
    //         <p className="m-0 p-0 pt-1 fw-bold text-primary">
    //           {expiryDate ? formatDate(expiryDate) : "--"}
    //         </p>
    //       </div>
    //     );
    //   },

    //   sortable: true,
    //   width: "160px",
    // },

    // //       {
    // //   name: "ROI Expiry Date",
    // //   selector: (row) => getRoiExpiryDate(row.createdOn),
    // //   cell: (row) => (
    // //     <div>
    // //       <p className="m-0 p-0 pt-1 fw-bold text-primary">
    // //         {getRoiExpiryDate(row.createdOn)}
    // //       </p>
    // //     </div>
    // //   ),
    // //   sortable: true,
    // //   width: "160px",
    // // },
    // {
    //   name: "ROI Age",
    //   selector: (row) => getRoiAgeMonthsDays(row.createdOn || row.createdDate),
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold text-primary">
    //         {getRoiAgeMonthsDays(row.createdOn || row.createdDate)}
    //       </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },

    //     {
    //       name: "AC Asset Type",
    //       selector: (row) => row.acAssetType || "--",
    //       cell: (row) => (
    //         <div>
    //           <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.acAssetType} </p>
    //         </div>
    //       ),
    //       sortable: true,
    //       width: "140px",
    //     },
    //     {
    //           name: "Asset Status",
    //           cell: (row) => (
    //             <TableStatusField status={row.assetActiveInactive ? "Active" : "Inactive"} />
    //           ),
    //           width: "130px",
    //         },
    {
      name: "Godown",
      selector: (row) => row.godown,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const value = row.godown;

        const color =
          value === "Rent" ? "red" : value === "Sale" ? "green" : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{value}</span>;
      },
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
                target={target.current}
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}

                  <strong>Remarks:</strong>
                  {row?.remarks || "--"}
                  <br />
                  <strong>Created By:</strong>
                  {row?.createdBy || "--"}
                  <br />
                  <strong>Created Date:</strong>
                  {row?.createdDate || "--"}
                  <br />
                  <strong>Updated Date:</strong>
                  {row?.updatedDate || "--"}
                  <br />
                  {/* <strong>Roi Code (Months):</strong>
                  {row?.roiCodeMonths || "--"}
                  <br />
                  <strong>ROI Profile Name:</strong>
                  {row?.roiProfileName || "--"}
                  <br />
                  <strong>Ac Asset Type:</strong>
                  {row?.acAssetType || "--"}
                  <br />
                  <strong>Effective Date:</strong>
                  {row?.effectiveDate || "--"}
                  <br /> */}
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "100px",
    },

    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteMaterial(row)}>
            {/* <i class="bi bi-trash3"></i> */}
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
      omit: true,
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const [getPropsData, setPropsData] = useState();
  const showAddProduct = (mode, materialnumber, data) => {
    setModalShowAddProduct(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };
  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };

  const showAddProduct12 = (mode, materialnumber, data) => {
    setModalShowAddProductMaterial(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModalMaterial = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProductMaterial(null);
    setModalShowDetailProduct(false);
  };

  useEffect(() => {
    let obj = {
      queryName: "MaterilBarcodeList",
      page: 1,
      per_page: 100,
    };
    dispatch(materialBarcodeList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeList",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };
  const handlePageChange = (page) => {
    let obj = {
      queryName: "MaterilBarcodeList",
      page: page,
      per_page: getNewPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    dispatch(materialBarcodeList(obj));
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "MaterilBarcodeList",
      page: page,
      per_page: newPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(materialBarcodeList(obj));
  };
  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeList",
  //     page: page,
  //     per_page: newPerPage,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(materialBarcodeList(obj));
  // };

  // Common Search Function on button
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "MaterilBarcodeList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };
  const handleSearchFuncApi = async () => {
    setActiveFilters([]); // ← clear filters when searching
    let obj = {
      queryName: "MaterilBarcodeList",
      page: 1,
      per_page: 100,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(materialBarcodeList(obj));
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  // const handleFilterData = async (filters) => {
  //   const obj = {
  //     queryName: "MaterilBarcodeList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: filters.length > 0 ? { $and: filters } : {},
  //   };

  //   // dispatch(getQtnJobList(obj));
  //   dispatch(materialBarcodeList(obj));

  //   // console.log(obj)
  // };

  const handleFilterData = async (filters) => {
    setActiveFilters(filters); // ← save filters
    const obj = {
      queryName: "MaterilBarcodeList",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };
    dispatch(materialBarcodeList(obj));
  };
  // const filterColumns = columns
  //   .filter((col) => col.id || col.selectorKey)
  //   .map((col) => ({
  //     name: col.name,
  //     selectorKey: col.id || col.selectorKey,
  //     dropDown: col.dropDown || false,
  //     range: col.range || false,
  //     month: col.month || false,
  //   }));
  const filterColumns = [
    {
      id: "barcode",
      name: "Barcode Value",
      selectorKey: "barcode",
    },
    {
      id: "materialCode",
      name: "Material Code",
      selectorKey: "materialCode",
    },
    {
      id: "mrPrice",
      name: "MRP",
      selectorKey: "mrPrice",
      numberRange: true,
    },
    {
      id: "materialStatus",
      name: "Stock",
      selectorKey: "materialStatus",
    },
    {
      id: "materialDescription",
      name: "Material Name",
      selectorKey: "materialDescription",
    },
    {
      id: "createdOn",
      name: "Date",
      selectorKey: "createdOn",
      month: true,
    },
  ];
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Barcode List</h2>
                <p className="subText">Material Barcode List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={filterColumns}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">
                        {" "}
                        Material Barcode Details
                      </span>
                      <span className="subHeaderTitle">
                        Material Barcode and ROI{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/*     <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              <i class="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                        </button>
                      </Col> */}
                      <Col xs={4} md={3} lg={3}>
                        <DownloadBarcodeTemplateMR />
                      </Col>
                      {isSalesAdmin && (
                        <Col xs={4} md={2} lg={2}>
                          <button
                            className="btnTable d-flex justify-content-center"
                            onClick={() => setShowBulkUpload(true)}
                          >
                            <i className="bi bi-upload me-1"></i> Bulk Upload
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_REPORT_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationPerPage={getNewPerPage}
                          paginationTotalRows={materialTable?.total || ""}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterialV5
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialBarCodeModal
        show={modalShowAddProduct}
        onHide={() => {
          setModalShowAddProduct(null);
          setModalShowDetailProduct(false);
        }}
        data={getPropsData}
        perPage={getNewPerPage}
        queryName="MaterilBarcodeList"
      />
      <MaterialBarcodeDetails
        key={getPropsData?.documentNumber || "barcode-details"}
        show={modalShowAddProductMaterial}
        // show={true}
        onHide={() => hideModalMaterial()}
        data={getPropsData}
      />
      <MaterialHBModalV5Barcode
        key={getPropsData?.documentNumber || "barcode-modal-material"}
        show={modalShowAddProductMaterial}
        // show={true}
        onHide={() => hideModalMaterial()}
        data={getPropsData}
      />
      <CatalogProductDetailModalV5
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <MaterialListQualityCheckModal
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        // editMode={editMode}
        onSaveQualityCheck={handleSaveQualityCheck}
      />
      {/* <BarcodeBulkUploadModal
        show={showBulkUpload}
        onHide={() => setShowBulkUpload(false)}
      /> */}
      <BarcodeBulkUploadModal
        show={showBulkUpload}
        onHide={() => setShowBulkUpload(false)}
        onSuccess={() => {
          dispatch(
            materialBarcodeList({
              queryName: "MaterilBarcodeList",
              page: 1,
              per_page: getNewPerPage,
            }),
          );
        }}
      />
    </main>
  );
};

export default MaterialBarcodeList;
